import script from "./taskCenterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./taskCenterCard.vue?vue&type=script&setup=true&lang=js"

import "./taskCenterCard.vue?vue&type=style&index=0&id=2a646ebc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a646ebc"]])

export default __exports__